import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube, Linkedin, Twitter, ArrowUpRight } from 'lucide-react';
import { siteInfo } from '../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_study-platform-27/artifacts/lmor3m0n_WhatsApp%20Image%202026-02-07%20at%2013.28.12.jpeg";

export const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/courses', label: 'Courses' },
    { path: '/about', label: 'About Us' },
    { path: '/technology', label: 'Technology' },
  ];

  const resourceLinks = [
    { path: '/gallery', label: 'Gallery' },
    { path: '/testimonials', label: 'Testimonials' },
    { path: '/contact', label: 'Contact Us' },
    { path: '/privacy', label: 'Privacy Policy' },
    { path: '/terms', label: 'Terms & Conditions' },
  ];

  const courseLinks = [
    { path: '/courses#clat', label: 'CLAT Preparation' },
    { path: '/courses#cuet', label: 'CUET Coaching' },
    { path: '/courses#ielts', label: 'IELTS Training' },
    { path: '/courses#spoken-english', label: 'Spoken English' },
  ];

  const socialLinks = [
    { icon: Instagram, href: siteInfo.socialLinks.instagram, label: 'Instagram' },
    { icon: Facebook, href: siteInfo.socialLinks.facebook, label: 'Facebook' },
    { icon: Youtube, href: siteInfo.socialLinks.youtube, label: 'YouTube' },
    { icon: Linkedin, href: siteInfo.socialLinks.linkedin, label: 'LinkedIn' },
    { icon: Twitter, href: siteInfo.socialLinks.twitter, label: 'Twitter' },
  ];

  return (
    <footer className="bg-[rgb(26,28,30)] border-t border-white/10 mt-32">
      <div className="max-w-[1200px] mx-auto px-6 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-6">
              <img
                src={LOGO_URL}
                alt="Scaleup Academy"
                className="h-12 w-auto object-contain"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-bold text-lg tracking-tight">
                  <span className="text-white">Scale</span><span className="text-[#F37021]">up</span>
                </span>
                <span className="text-[10px] text-[rgb(161,161,170)] tracking-wider uppercase">Empowering Learning</span>
              </div>
            </Link>
           <p className="text-[rgb(161,161,170)] text-sm leading-relaxed mb-6">
  A focused academic institute for CLAT, IPMAT and CUET preparation, delivering structured mentoring and measurable outcomes for students and schools.
</p>

            <div className="flex gap-2">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-10 h-10 rounded-lg bg-[rgb(38,40,42)] flex items-center justify-center text-[rgb(161,161,170)] hover:bg-[#F37021] hover:text-white transition-all duration-200 hover:-translate-y-0.5"
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-[rgb(161,161,170)] hover:text-[#F37021] text-sm transition-colors duration-200 flex items-center gap-1 group"
                  >
                    {link.label}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </Link>
                </li>
              ))}
              {resourceLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-[rgb(161,161,170)] hover:text-[#F37021] text-sm transition-colors duration-200 flex items-center gap-1 group"
                  >
                    {link.label}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h4 className="text-white font-semibold text-base mb-6">Our Courses</h4>
            <ul className="space-y-3">
              {courseLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-[rgb(161,161,170)] hover:text-[#F37021] text-sm transition-colors duration-200 flex items-center gap-1 group"
                  >
                    {link.label}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-base mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${siteInfo.phone}`} className="flex items-start gap-3 text-[rgb(161,161,170)] hover:text-[#F37021] text-sm transition-colors duration-200">
                  <Phone size={16} className="mt-0.5 flex-shrink-0" />
                  {siteInfo.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${siteInfo.email}`} className="flex items-start gap-3 text-[rgb(161,161,170)] hover:text-[#F37021] text-sm transition-colors duration-200">
                  <Mail size={16} className="mt-0.5 flex-shrink-0" />
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-[rgb(161,161,170)] text-sm">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                {siteInfo.address}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[rgb(161,161,170)] text-sm">
            &copy; {new Date().getFullYear()} Scaleup Academy. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-[rgb(161,161,170)] hover:text-[#F37021] text-sm transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-[rgb(161,161,170)] hover:text-[#F37021] text-sm transition-colors duration-200">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
